import { APPLICATION_CONNECTED, APPLICATION_DISCONNECTED } from './application.constants';
import { Application } from '../../models/entities';
import { StoreNative } from '..';

export function applicationReducer(state: StoreNative<Application> = {} as StoreNative<Application>, action: { type: string; payload: any }) {
    let newState = state;
    if (action && action.type) {
        switch (action.type) {
            case APPLICATION_CONNECTED:
                newState = {
                    hasError: false,
                    isLoaded: true,
                    isLoading: false,
                    value: action.payload
                };
                break;
            case APPLICATION_DISCONNECTED:
                newState = {
                    hasError: false,
                    isLoaded: true,
                    isLoading: false,
                    value: {} as Application
                };
                break;
        }
    }
    return newState;
}